import Vue from "vue";
import VueTyperPlugin from "vue-typer";
Vue.use(VueTyperPlugin);
